import React from 'react';
import translate from '@/utils/translate';

export default function EmptyPreviewState() {
    return (
			<section className="empty-preview-state">
				<div className="container">
					<div className="row empty-preview-state-container">
						<div className="col-md-8 col-lg-6 text-center">
							<div className="empty-preview-state-illustration">
								<svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#emptyStateSidebarLeftClip)">
										<rect x="35" y="45" width="130" height="100" rx="6" fill="#FFFFFF" stroke="#D1D6E0" strokeWidth="1.5"></rect>
										<rect x="35" y="45" width="130" height="25" rx="6" fill="#F0F4FF"></rect>
										<rect x="35" y="58" width="130" height="12" fill="#F0F4FF"></rect>
										<circle cx="48" cy="57.5" r="3.5" fill="#FF5A5A"></circle>
										<circle cx="60" cy="57.5" r="3.5" fill="#FFBD2E"></circle>
										<circle cx="72" cy="57.5" r="3.5" fill="#27C93F"></circle>
										<circle cx="150" cy="80" r="18" fill="#3448C5"></circle>
										<line x1="150" y1="70" x2="150" y2="90" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round"></line>
										<line x1="140" y1="80" x2="160" y2="80" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round"></line>
										<rect x="50" y="80" width="55" height="50" rx="4" fill="#B6D2FF"></rect>
										<rect x="58" y="88" width="39" height="6" rx="2" fill="#FFFFFF" opacity="0.8"></rect>
										<rect x="58" y="98" width="30" height="6" rx="2" fill="#FFFFFF" opacity="0.6"></rect>
										<rect x="58" y="108" width="25" height="6" rx="2" fill="#FFFFFF" opacity="0.4"></rect>
										<rect x="72" y="88" width="20" height="20" rx="3" fill="#FFFFFF" opacity="0.7"></rect>
										<circle cx="78" cy="94" r="4" fill="#B6D2FF"></circle>
										<path d="M88 104L84 100L80 104L76 100L72 104" stroke="#B6D2FF" strokeWidth="1.5" fill="none"></path>
										<rect x="112" y="100" width="45" height="35" rx="4" fill="#F5B361"></rect>
										<rect x="118" y="108" width="32" height="5" rx="2" fill="#FFFFFF" opacity="0.8"></rect>
										<rect x="118" y="117" width="25" height="5" rx="2" fill="#FFFFFF" opacity="0.6"></rect>
										<rect x="50" y="135" width="85" height="8" rx="4" fill="#C6D1DB"></rect>
										<circle cx="40" cy="35" r="3" fill="#F5B361" opacity="0.8"></circle>
										<circle cx="170" cy="40" r="2.5" fill="#3448C5" opacity="0.6"></circle>
										<circle cx="175" cy="145" r="2" fill="#28BBFA" opacity="0.7"></circle>
										<circle cx="30" cy="160" r="2.5" fill="#F5B361" opacity="0.5"></circle>
										<circle cx="185" cy="60" r="1.5" fill="#28BBFA" opacity="0.8"></circle>
										<rect x="55" y="158" width="90" height="3" rx="1.5" fill="#D1D6E0" opacity="0.5"></rect>
										<rect x="75" y="165" width="50" height="3" rx="1.5" fill="#D1D6E0" opacity="0.3"></rect>
									</g>
								</svg>
							</div>
							<h2 className="empty-preview-state-title">{translate("No sections added yet")}</h2>
							<p className="empty-preview-state-description">
								{translate("Choose your first section to start structuring your layout.")}
							</p>
						</div>
					</div>
				</div>
			</section>
			);
}